import {SerialNumbersApiDto} from "../../api/model/rest";
import {none, Option, option} from "ts-option";
import JsonConverter from "../../api/helper/JsonConverter";

export default class SerialNumbersData {
	/**
	 * Serial numbers data object
	 * @param {Option<string>} boiler serial number
	 * @param {Option<string>} cylinder serial number
	 * @param {Option<string>} filter serial number
	 * @param {Option<string>} control serial number
	 */
	constructor(public readonly boiler: Option<string>,
		public readonly cylinder: Option<string>,
		public readonly filter: Option<string>,
		public readonly control: Option<string>) {}


	public static fromJson(json: SerialNumbersApiDto): SerialNumbersData {
		const boiler = json.boiler ? option(json.boiler) : none;
		const cylinder = json.cylinder ? option(json.cylinder) : none;
		const filter = json.filter ? option(json.filter) : none;
		const control = json.control ? option(json.control) : none;

		return new SerialNumbersData(boiler, cylinder, filter, control)
	}

	toJson(): SerialNumbersApiDto {
		const json: SerialNumbersApiDto = {
			boiler: this.boiler.orNull,
			cylinder: this.cylinder.orNull,
			filter: this.filter.orNull,
			control: this.control.orNull
		};
		return JsonConverter.removeEmptyFields(json);
	}

	isDefined(): boolean {
		return this.boiler.isDefined || this.cylinder.isDefined || this.filter.isDefined || this.control.isDefined;
	}

	getText(): string {
		return this.boiler.map(b => `Boiler: ${b} `).getOrElse("") +
			this.cylinder.map(c => `Cylinder: ${c} `).getOrElse("") +
			this.filter.map(f => `Filter: ${f} `).getOrElse("") +
			this.control.map(c => `Control: ${c} `).getOrElse("");
	}
}